import React from 'react';
import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

const StyledStatCard = styled.div`
  width: 100%;
  height: 150px;
  border: 0.5px solid ${COLOR.indigo[8]};
  border-radius: 16px;
  background: linear-gradient(
    156.92deg,
    #f8fafc 0%,
    rgba(239, 246, 255, 0.3) 50%,
    rgba(224, 231, 255, 0.5) 100%
  );
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .stat-icon {
    width: 24px;
    height: 24px;
    color: ${COLOR.darkBlue};
    flex-shrink: 0;
  }

  .stat-label {
    font-size: 16px;
    font-weight: 400;
    color: ${COLOR.label2[64]};
    margin-top: 8px;
    line-height: 1.5;
  }

  .stat-value {
    font-size: 32px;
    font-weight: 700;
    color: ${COLOR.darkGray};
    margin-top: 8px;
    line-height: 1.2;
  }
`;

const StatCard = ({ icon, label, value }) => (
  <StyledStatCard>
    <div className="stat-icon">{icon}</div>
    <div className="stat-label">{label}</div>
    <div className="stat-value">{value}</div>
  </StyledStatCard>
);

export default StatCard;
